import { Generic } from './Banner';
export function isBanner(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isBanner;    //# sourceMappingURL=isBanner.js.map
